import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'

import { Text } from 'components/base'
import * as Icons from 'components/Utils/Icons'

const itemsPricing = [
  {
    label: 'Unlimited docs',
    subtitle: '(50 shared docs per 30 rolling days in free)',
  },
  {
    label: 'Unlimited integrations',
    subtitle: '(limited to 3 in free)',
  },
  {
    label: 'Full version history',
    subtitle: '(limited to last 3 versions in free)',
  },
  {
    label: 'Full docs activity logs',
    subtitle: '(limited to 3 in free)',
  },
  {
    label: 'Invitation management',
    subtitle: 'all members can invite in free',
  },
  {
    label: 'Sharing administration',
    subtitle: 'all members can share documents in free',
  },
  {
    label: 'Priority support',
  },
  {
    label: 'Team insights',
  },
  {
    label: 'SSO authentication (Enforced Google SSO, OpenID Connect)',
  },
  {
    label: 'User groups',
  },
  {
    label: 'Remove Slite branding from exports and shared links',
  },
  {
    label: 'Automated backups',
  },
  {
    label: 'Up to 200MB per attachement',
    subtitle: '(limited to 10MB in free)',
  },
  {
    label: '10GB/user storage',
    subtitle: '(2GB/team in free)',
  },
]

class PlanDescription extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  static defaultProps = {
    title: 'Standard plan',
  }

  render() {
    const { children, title } = this.props

    return (
      <div
        className={classNames(
          'width-full',
          'background-shade-100 shadow-normal radius-large',
          'flexbox flexbox-column flexbox-align-center',
          'padding-vertical-larger padding-horizontal-huge'
        )}
      >
        <Text.Subtitle className="primary margin-bottom-medium">
          {title}
        </Text.Subtitle>
        {children}
        <div className="width-full">
          {itemsPricing.map((item, index) => (
            <div
              key={index}
              className="flexbox flexbox-align-center margin-bottom-large"
            >
              <Icons.CheckMarkIcon
                size={16}
                className="primary margin-right-normal"
              />
              <div>
                <Text.EditorCorpus inline>{item.label}</Text.EditorCorpus>
                {item.subtitle && (
                  <Text.Detail inline className="margin-left-small">
                    {item.subtitle}
                  </Text.Detail>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default PlanDescription
